// Which screen a side panel hangs off.
//
// ⚠️ THE PANEL BELONGS TO THE SCREEN THAT OWNS THE SNIPPET, NOT TO THE SNIPPET, and the two
// disagree in exactly one place. The candidate snippet appears on its own route AND inside the
// review's side view; on its own route the three panels are its children, but inside the
// review the strip's events are handled by the REVIEW component, whose `addToJobState` is
// `HunterReviewAddToJob` (`extension-alert-candidates.component.ng1.ts:237`) — a SIBLING of the
// profile. `routes.json` agrees: there is no `…/review/candidate/profile/add-to-job`, so
// deriving the base from the current path alone navigates to a route that does not exist.
//
// A function with a test rather than three lines in two components, because the version that
// did not know this rule type-checked, rendered and passed every other gate.

const SHORTLIST_REVIEW = '/chrome-extension/extension/shortlist/review'
const CLIENT_CONTACT_REVIEW = '/chrome-extension/extension/client-contact/review'

/**
 * `pathname` is the snippet's own route, with or without a trailing `/more`. The answer is the
 * path a panel leaf is appended to.
 */
export function panelBase(pathname: string): string {
  if (pathname.includes('/review/candidate/profile')) return SHORTLIST_REVIEW
  if (pathname.includes('/review/client-contact/profile')) return CLIENT_CONTACT_REVIEW
  // ⚠️ EVERY CHILD OF THE PROFILE, NOT ONLY `more`. The strip stays clickable while a side panel
  // is open, and a sibling's leaf appended to an open panel's path is a route that does not exist
  // (`…/profile/export/add-to-job`). ui-router's `$state.go` is absolute, so upstream never had to
  // trim anything.
  return pathname.replace(/\/(more|add-to-job|candidate-messages|client-contact-messages|email-signin|export)$/, '')
}
